import getBasePath from '@/produto/common/functions/api-resource';

const basePath = getBasePath('planejamento_acao', 'planejamento-contrato-akzo');

const planejamentoOrcamentoActions = {
  existeContrato: { method: 'GET', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, planejamentoOrcamentoActions);
